/* global BigInt */
export const kinds = {
  income: 'Приход',
  expense: 'Расход',
  income_refund: 'Возврат клиенту',
  expense_refund: 'Возврат от сервиса',
  transfer: 'Перевод / пополнение',
  opening: 'Начальный остаток',
  reversal: 'Отмена записи',
};
export function money(value, currency = 'RUB') {
  const n = BigInt(String(value || 0));
  const absolute = n < 0n ? -n : n;
  return `${n < 0n ? '−' : ''}${(absolute / 100n).toLocaleString('ru-RU')},${String(absolute % 100n).padStart(2, '0')} ${currency === 'RUB' ? '₽' : '$'}`;
}
export function minor(value) {
  const text = String(value).trim().replace(',', '.');
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(text))
    throw new Error(
      'Укажите положительную сумму, не более двух знаков после запятой.'
    );
  const [whole, fraction = ''] = text.split('.');
  const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (!Number.isSafeInteger(amount) || amount < 1 || amount > 100000000000)
    throw new Error('Проверьте сумму.');
  return amount;
}
export function split(amount, ids) {
  if (!ids.length) return [{ group_entry_id: null, amount_minor: amount }];
  if (amount < ids.length)
    throw new Error(
      'Сумма должна позволять выделить хотя бы одну копейку каждой группе.'
    );
  return ids.map((id, i) => ({
    group_entry_id: Number(id),
    amount_minor:
      Math.floor(amount / ids.length) + (i < amount % ids.length ? 1 : 0),
  }));
}
export function today() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Moscow',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}
export function formPayload(form) {
  const amount = minor(form.amount);
  if (!form.description.trim()) throw new Error('Укажите назначение операции.');
  if (!form.category.trim()) throw new Error('Укажите категорию.');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(form.date)) throw new Error('Укажите дату.');
  if (!form.wallet) throw new Error('Выберите счёт.');
  const result = {
    kind: form.kind,
    amount_minor: amount,
    currency: form.currency,
    occurred_on: form.date,
    category: form.category.trim(),
    description: form.description.trim(),
    wallet_id: Number(form.wallet),
  };
  if (form.kind === 'transfer') {
    if (!form.target || form.target === form.wallet)
      throw new Error('Выберите другой счёт для зачисления.');
    result.target_wallet_id = Number(form.target);
  } else if (form.kind !== 'opening') {
    result.allocations =
      form.allocationMode === 'manual'
        ? form.groupIds.map(id => ({
            group_entry_id: Number(id),
            amount_minor: minor(form.shares[id]),
          }))
        : split(amount, form.groupIds);
    if (
      result.allocations.reduce((sum, row) => sum + row.amount_minor, 0) !==
      amount
    )
      throw new Error('Сумма долей должна совпадать с суммой операции.');
  }
  if (form.userId) {
    if (
      !/^[1-9]\d*$/.test(form.userId) ||
      Number(form.userId) > 4503599627370495
    )
      throw new Error('Проверьте Telegram ID клиента.');
    result.telegram_user_id = Number(form.userId);
  }
  if (form.original) result.original_entry_id = Number(form.original);
  return result;
}

export function providerMoney(value) {
  const text = String(value);
  if (!/^\d{1,12}(?:\.\d{1,6})?$/.test(text)) return 'Нет данных';
  const [whole, fraction = ''] = text.split('.');
  return `${BigInt(whole).toLocaleString('ru-RU')},${fraction.padEnd(2, '0')} ₽`;
}
